import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivateChildFn,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { MenuPointService, NavVariant } from '@agilox/common';
import { UserStoreService } from '@user-store';
import { Observable } from 'rxjs';
import { MenuPointUrl } from '../shared/enums/menupoint-url.enum';

export const roleGuard: CanActivateChildFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	const userStore = inject(UserStoreService);
	const menuPointService = inject(MenuPointService);
	const router = inject(Router);

	const user = userStore.currentUser();
	if (!user) {
		return router.parseUrl(MenuPointUrl.dashboards);
	}

	const menuPoints = menuPointService.getMenuPointsByCategory(NavVariant.DESKTOP, user.role);
	const hasAccess = menuPoints.some((mp) => state.url.includes(mp.url));

	if (hasAccess) {
		return true;
	}

	return router.parseUrl(MenuPointUrl.dashboards);
};
